import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Admin.css";
import { vandalAuth } from "../../utils/Auth";
import api from "../../utils/Api";

import SignOutIcon from "../../images/adminSignOut.svg";
import AdminPeople from "../../images/adminPeople.svg";
import AdminFilePlus from "../../images/adminFilePlus.svg";

import Colors from "../../images/adminColorsBlue.svg";
import Diff from "../../images/adminDiffBlue.svg";
import Razm from "../../images/adminRazmBlue.svg";

import Del from "../../images/adminDel.svg";

import AdminPopup from "../AdminPopup/AdminPopup";
import AdminProfiles from "../AdminProfiles/AdminProfiles";

function Admin() {
  //переменные
  const [user, setUser] = useState(null);
  const [cards, setCards] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openPopup, setOpenPopup] = useState(false);
  const [cardPatch, setCardPatch] = useState(false);
  const [cardPatchInfo, setCardPatchInfo] = useState(null);
  const [isChecked, setIsChecked] = useState([]);
  const [newUser, setNewUser] = useState(false);
  const navigate = useNavigate();

  //первоначальный запрос на человека и карточку
  useEffect(() => {
    vandalAuth.getUserProfile().then((data) => {
      if (data.error) {
        navigate("/signin");
      } else if (data.user) {
        setUser(data.user);
        api.getCardsUser().then((data) => {
          console.log(data);
          setCards(data.slice().reverse());
          setLoading(false);
        });
      }
      console.log(data);
    });
  }, []);

  const handleCheckboxChange = (id) => {
    setIsChecked((prev) => {
      // Проверяем, если id уже есть в массиве, то убираем его, иначе добавляем
      if (prev.includes(id)) {
        return prev.filter((checkedId) => checkedId !== id); // Убираем id, если уже есть
      } else {
        return [...prev, id]; // Добавляем id, если его нет
      }
    });
    console.log(isChecked);
  };

  useEffect(() => {
    console.log("isChecked изменен:", isChecked); // Отслеживаем изменения isChecked
  }, [isChecked]);

  //функция получения карточек
  function getCards() {
    setLoading(true);
    api.getCardsUser().then((data) => {
      console.log(data);
      setCards(data);
      setLoading(false);
    });
  }

  return (
    <div className="Admin">
      {isChecked.length > 0 && (
        <img
          src={Del}
          onClick={() => {
            api.deleteCard(isChecked).then((data) => {
              if (data.message === "Карточки успешно удалены.") {
                getCards();
                setIsChecked([]);
              }
            });
          }}
          className="Admin__del"
        />
      )}

      <div className="admin__header">
        <div className="admin__header__container">
          <p className="admin__header__container__title">
            Панель администратора
          </p>
          <p className="admin__header__container__admins">
            {user
              ? user.admins === "yes"
                ? "Senior Administrator"
                : "Standard employee"
              : null}
          </p>
        </div>
        <button
          onClick={() => {
            localStorage.clear("jwt");
            navigate("/signin");
          }}
          className="admin__header__signoutbtn"
        >
          <img alt="icon" src={SignOutIcon} /> Выйти из панели администратора
        </button>
      </div>
      <div className="admin__btncont">
        <input
          placeholder="Поиск артикула"
          className="admin__btncont__input"
          type="text"
        />
        <button
          onClick={() => {
            setOpenPopup(true);
          }}
          className="admin__btncont__btn"
        >
          <img alt="icon" src={AdminFilePlus} />
          Создать новый файл
        </button>
        {user ? (
          user.admins === "yes" ? (
            <button onClick={() => {
              setNewUser(true)
            }} className="admin__btncont__btn">
              <img alt="icon" src={AdminPeople} />
              Сотрудники
            </button>
          ) : null
        ) : null}
      </div>
      <div className="admin__cards">
        {loading && (
          <div className="admin__cards__loader">
            <div className="admin__cards__loader__circle one"></div>
            <div className="admin__cards__loader__circle two"></div>
            <div className="admin__cards__loader__circle three"></div>
          </div>
        )}
        {!loading && cards && cards.length === 0 && (
          <p className="admin__cards__none">Ничего не найдено!</p>
        )}
        {!loading &&
          cards &&
          cards.length > 0 &&
          cards.map((card, index) => (
            <div key={card.id} className="admin__card">
              <input
                type="checkbox"
                id={`customCheckbox-${index}`}
                className="admin__start__cards__card__input"
                checked={isChecked.includes(card.id)}
                onChange={() => handleCheckboxChange(card.id)}
              />
              <label htmlFor={`customCheckbox-${index}`}></label>
              <img
                alt="img"
                className="admin__card__img"
                src={`https://vandalvisionteam-vandalvision-servernew-8cf3.twc1.net/uploads/${card.article}/${card.images.webp}`}
              />
              <div className="admin__card__con">
                <p className="admin__card__con__title">{card.article}</p>
                <div className="admin__card__con__con">
                  <p className="admin__card__con__con__info">
                    <img alt="razm" src={Razm} />
                    Размер: {card.size}
                  </p>
                  <p className="admin__card__con__con__info">
                    <img alt="color" src={Colors} />
                    Цветов: {card.colors}
                  </p>
                  <p className="admin__card__con__con__info">
                    <img alt="diff" src={Diff} />
                    Сложность:{" "}
                    <div
                      className={`${
                        card.difficulty === "easy" && "AdminDiffGreen"
                      } ${card.difficulty === "normal" && "AdminDiffOrange"} ${
                        card.difficulty === "hard" && "AdminDiffRed"
                      }  adminDiff`}
                    >
                      {card.difficulty === "easy" && "Легко"}{" "}
                      {card.difficulty === "normal" && "Средняя"}{" "}
                      {card.difficulty === "hard" && "Сложно"}
                    </div>
                  </p>
                </div>
                <div className="admin__card__con__btns">
                  <button
                    className="admin__card__con__btns__btn"
                    onClick={() => {
                      setOpenPopup(true);
                      setCardPatch(true);
                      setCardPatchInfo(card);
                    }}
                  >
                    Редактировать
                  </button>
                  <button
                    onClick={() => {
                      api.deleteCard(card.id).then((data) => {
                        if (data.message === "Карточки успешно удалены.") {
                          getCards();
                        }
                      });
                    }}
                    className="admin__card__con__btns__btn"
                  >
                    Удалить
                  </button>
                </div>
              </div>
            </div>
          ))}
      </div>

      {openPopup && (
        <AdminPopup
          cards={cards}
          setOpenPopup={setOpenPopup}
          setCardPatchInfo={setCardPatchInfo}
          cardPatchInfo={cardPatchInfo}
          cardPatch={cardPatch}
          setCardPatch={setCardPatch}
          getCards={getCards}
        />
      )}
      {newUser && <AdminProfiles setNewUser={setNewUser} />}
    </div>
  );
}

export default Admin;
